
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateFormatPipe, IAction, LanguageService } from '@aston/foundation';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AsyncPipe } from '@angular/common';

import { ISubsidiaryUser } from '../../models';
import { UserStatus } from '../../enums';


@Component({
    selector: 'middle-users-status-actions',
    imports: [AsyncPipe, TranslateModule, NgbTooltipModule],
    templateUrl: './middle-users-status-actions.component.html',
    providers: [
        DateFormatPipe,
    ]
})
export class MiddleUsersStatusActionsComponent implements OnInit {
	@Input({ required: true }) user!: ISubsidiaryUser;

	@Output() changeStatus = new EventEmitter<UserStatus>();
	@Output() sendRegistrationRequest = new EventEmitter<void>();
	@Output() viewDelegation = new EventEmitter<IAction>();
	@Output() editDelegation = new EventEmitter<IAction>();
	@Output() editInactivity = new EventEmitter<IAction>();

	UserStatus = UserStatus;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	do!: { resend: any, start: any, stop: any, view: any, edit: any };
	statusTooltip$: Observable<string> = EMPTY;

	constructor(
		private dateFormatPipe: DateFormatPipe,
		private languageService: LanguageService,
		private translateService: TranslateService,
	) {}

	ngOnInit() {
		const active = this.user.userStatus === UserStatus.Active;
		const inactive = this.user.userStatus === UserStatus.Inactive;
		const inactStart = this.user.inactivityBeginDate;
		const today = new Date;

		this.do = {
					// pending invitation
			resend: (active || inactive) ? false : () => this.sendRegistrationRequest.emit(),

					// inactive => active
			start:	!inactive ? false : () => this.changeStatus.emit(UserStatus.Active),

					// active => inactive (only when no inactivity planned)
			stop:	(!active || (inactStart && inactStart > today))
													 ? false : () => this.changeStatus.emit(UserStatus.Inactive),

					// pending invitation
			view:	(!active  && !inactive)        ? false :
					// active, no inactivity planned
					(active   && !inactStart)        ? ((evt: IAction) => this.viewDelegation.emit(evt)) :
					false,

					// pending invitation
			edit:	(!active  && !inactive)          ? false :
					// active, inactivity planned
					(active   && inactStart > today) ? ((evt: IAction) => this.editInactivity.emit(evt)) :
					// inactive, in inactivity period
					(inactive && inactStart)         ? ((evt: IAction) => this.editInactivity.emit(evt)) :
					// inactive, in being delegated
					(inactive && !inactStart)        ? ((evt: IAction) => this.editDelegation.emit(evt)) :
					false,
		};

		this.statusTooltip$ = this.languageService.language$.pipe(
			filter(_ => !!inactStart),
			map(_ => [
				this.user.inactivityBeginDate,
				this.user.inactivityEndDate,
			]),
			map(params => params.filter(Boolean).map(d => this.dateFormatPipe.transform(d))),
			map(params => params.length > 1 ?
				this.translateService.instant('InactivityPeriod.Tooltip', params) :
				this.translateService.instant('InactivityPeriod.TooltipStart', params)
			)
		);
	}
}
